import type { ThermoState } from '../../shared/protocol';
import { formatCountdown, metersToFeet } from '../util/format';
import { useServerClock } from '../util/clock';

/** Thermometer HUD (seeker, §4.8.4): live displacement vs the minimum, window
 *  countdown, and a Stop-early gate that unlocks at the minimum. */
export function ThermoHud({
  thermo,
  serverNow,
  onStop,
}: {
  thermo: ThermoState;
  serverNow: number;
  onStop: () => void;
}) {
  const now = useServerClock(serverNow, [thermo.endsAt]);
  const left = Math.max(0, thermo.endsAt - now());
  const disp = metersToFeet(thermo.displacementM);
  const pct = Math.min(100, (thermo.displacementM / (thermo.minFt * 0.3048)) * 100);

  return (
    <div className="thermo-hud" data-testid="thermo-hud">
      <div className="thermo-hud__row">
        <span className="thermo-hud__disp" data-testid="thermo-disp">
          {disp} <span className="thermo-hud__min">/ {thermo.minFt} ft</span>
        </span>
        <span className="thermo-hud__count">{formatCountdown(left)} left</span>
      </div>
      <div className="thermo-hud__track">
        <div className="thermo-hud__bar" style={{ width: `${pct}%` }} />
      </div>
      <button
        className="btn btn--signal"
        disabled={!thermo.canStopEarly}
        data-testid="thermo-stop"
        onClick={onStop}
      >
        {thermo.canStopEarly ? 'Stop early' : `Walk ${thermo.minFt} ft to stop`}
      </button>
    </div>
  );
}
